import React from 'react';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 py-12">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="text-center md:text-left">
          <HashLink smooth to="/#top" className="text-xl font-bold text-slate-900">
            Marjo Villarosa
          </HashLink>
          <p className="text-slate-500 text-sm mt-2">
            Building trust in a digital world.
          </p>
        </div>
        
        <div className="flex gap-8 text-sm font-medium text-slate-600">
          <HashLink smooth to="/#about" className="hover:text-teal-600 transition-colors">About</HashLink>
          <HashLink smooth to="/#projects" className="hover:text-teal-600 transition-colors">Projects</HashLink>
          <HashLink smooth to="/#contact" className="hover:text-teal-600 transition-colors">Contact</HashLink>
        </div>

        <div className="text-slate-400 text-sm">
          &copy; {new Date().getFullYear()} Marjo Villarosa. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;